export default __webpack_public_path__ + "static/media/t33.bda448df.jpg";